import Header from "../components/Header";
import Footer from "../components/Footer";
import { Container, Typography } from "@mui/material";
import Flexbox from "../components/Flexbox";
import Spacebox from "../components/Spacebox";
import { isMobile } from "react-device-detect";

const GHLCALENDER = `<iframe src="https://api.leadconnectorhq.com/widget/booking/5Tg8pgEN1CQDXQV13zwb" style="width: 100%;border:none; height:500px; overflow: hidden;" scrolling="yes" id="5Tg8pgEN1CQDXQV13zwb_1742347249794"></iframe><br><script src="https://link.msgsndr.com/js/form_embed.js" type="text/javascript"></script>`

const Booking = ({ title }) => {

    document.querySelector('title').innerHTMl = title

    return (
        <div className="careers-page">
            <Header />
            <section>
                <Flexbox justifyContent="center" alignItems="center">
                    <Container>
                        <Spacebox padding="20px" />
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                            Schedule a Consultation
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                        Book a time to speak with our team about your business funding needs. We're here to help you find the right financial solution.
                        </Typography>
                        <Spacebox padding="50px" />
                        <div className="margin-auto" style={{ padding: isMobile ? '0px' : '20px', borderRadius: '10px', border: isMobile ? '0px solid transparent' : '1px solid #4A3FFF20', height: '500px', width: isMobile ? '100%' : '700px' }} dangerouslySetInnerHTML={{ __html: GHLCALENDER }}></div>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                    </Container>
                </Flexbox>
            </section>
            <Footer />
        </div>
    );
}

export default Booking;
